import { makeStyles, Theme } from '@material-ui/core/styles';
import { SecondaryColors, TextColors } from '@/utils/constants';

const useTabbedListContentStyles = makeStyles(
  (muiTheme: Theme) => ({
    root: {
      width: '100%',
      '& .tabs-header': {
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: muiTheme.spacing(6),
        alignItems: 'center',
        '& .tabbed-list-content-tabs': {
          position: 'relative',
          zIndex: 2,
          '& .MuiSvgIcon-root': {
            fill: `${SecondaryColors.main} !important`,
          },
        },
        [muiTheme.breakpoints.down('sm')]: {
          justifyContent: 'center',
          marginLeft: muiTheme.spacing(-4),
          marginRight: muiTheme.spacing(-4),
          '& .MuiTabs-scrollButtons': {
            width: muiTheme.spacing(-4),
          },
        },
      },
      '& .tabs-content': {
        '& .detail-content > *': {
          width: '100%',
          marginBottom: muiTheme.spacing(4),
        },
        '& .detail-content > *:last-child': {
          marginBottom: 0,
        },
      },
    },
    tab: {
      minWidth: 'auto !important',
      padding: muiTheme.spacing(1),
      marginRight: muiTheme.spacing(3),
      '& > span': {
        color: TextColors.light,
      },
    },
    heading: {
      color: TextColors.light,
      marginBottom: `${muiTheme.spacing(2)}px !important`,
    },
  }),
  { name: 'TabbedListContent' },
);

export default useTabbedListContentStyles;
